/**
 * Renders a tooltip element
 *
 * @property {boolean} [brief]
 * @property {string} content
 * @property {boolean} [down]
 * @property {boolean} [hideLabel]
 * @property {icon} [icon]
 * @property {string} id
 * @property {boolean} [left]
 * @property {boolean} [right]
 */

import React from 'react';

const RoomTooltip = class RoomTooltip extends React.Component {
    render() {
        const { brief, content, down, hideLabel, icon, id, left, right } = this.props;

        return (
            <div
                className={
                    `room-tooltip${
                        brief ? ' room-tooltip--brief' : ''
                    }${
                        down ? ' room-tooltip--down' : ''
                    }${
                        left ? ' room-tooltip--left' : ''
                    }${
                        right ? ' room-tooltip--right' : ''
                    }`
                }
            >
                {!hideLabel &&
                <span
                    className="room-tooltip__label"
                    role="presentation"
                    aria-hidden="true"
                >
            (?)
          </span>
                }

                {icon ? icon : ''}

                <div
                    id={id}
                    className="room-tooltip__body"
                    role="tooltip"
                >
                    {content}
                </div>
            </div>
        )
    }
}

export default RoomTooltip;



// WEBPACK FOOTER //
// ./src/app/components/Common/RoomTooltip.js